import React, { useState } from "react";
import singam from "./Im/singam.png"
import boss from "./Im/boss.png"
import sivaji from "./Im/sivaji.png";
import vijay from "./Im/vijay.png";
import telugu_h from "./Im/telugu_h.png"
import o_im from "./Im/o_im.png"
import ynot from "./Im/ynot.jpg"
import hundred from "./Im/hundred-point.png"
import reliance from "./Im/reliance.png";
import avm from "./Im/avm.jpg"
import tsl from "./Im/tsl.png"
import mango from "./Im/mango.png"
import right from "./Im/right.png"
import "./home_middle.css";
import introvideo from "./Im/Video_1.mp4"
import poster from "./Im/maranamasss.png"
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import Collections_sub from "../../Pages/collections-sub/Collections_sub";
import axios from "axios";
import Top_selling_products from "./Top_selling_products";
import Countdown from 'react-countdown';
import Movies from "./Movies";
import rocket from './Im/hprocket.png'
import sivajilogo from './Im/sivajilogo.png'
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

export default function Top_selling() {

    let history = useHistory();

    //Skeleton Loader Division function
    setTimeout(function () {
        const display = document.getElementById("video_skeleton_loader").style.display;
        if (display == "") {
            document.getElementById("video_skeleton_loader").style.display = "none";
            document.getElementById("intro_video_section").style.display = "";
            console.log("Skeleton Function Executed...")
        }
    }, 3000);

    return (




        <div className="top_selling">
            <h1 className="top-selling-heading">TOP SELLING COLLECTION <img className="hundred" src={hundred} /></h1>

            {/*Skeleton Loader Division , Please Donot Remove the Division */}
            <div className="video" id="video_skeleton_loader" style={{ display: '' }}>
                <Skeleton baseColor="#080824" highlightColor="#b1b2bc" height={200} />
            </div>
            {/*Skeleton Loader Division End From Here*/}

            <div className="video" id="intro_video_section" style={{ display: 'none' }}>
                <video id="background-video" autoPlay loop muted poster={poster}>
                    <source src={introvideo} type="video/mp4" />
                </video>
                <div className="video-text">

                </div>
            </div>
            {/*   <div className="marana_mass">
                    <p className="maranamass-text">Marana mass<br></br> moment</p>
                    <p className="mass-para">Collect them all at $299</p>
</div>*/}
            {/* <div className="movies">
            ""
            <div className="singam">
                <img onClick={() => {
                    history.push("/collections-sub");
                }} className="singam" src={singam} alt="Logo" />

                <h1 className="singam-text">Singam</h1>
                <button className="load-bt"></button>
                <button className="load-bt"></button>
                <button className="load-bt"></button>
                <button className="load-bt"></button>
                <button className="load-bt"></button>
                <button className="load-bt"></button>
            </div>
            <div className="movie-list">
                <div className="movie-block" >
                    <img onClick={() => {
                        history.push("/collections-sub");
                    }} className="movie-block" src={telugu_h} alt="Logo" />
                    <h3 className="movie-text">Fear  him</h3>
                    <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                </div>
                <div className="movie-block">
                    <img onClick={() => {
                        history.push("/collections-sub");
                    }} className="movie-block" src={boss} alt="Logo" />
                    <h3 className="movie-text">Motta boss still</h3>
                    <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                </div>
                <div className="movie-block2">
                    <img onClick={() => {
                        history.push("/collections-sub");
                    }} className="movie-block" src={sivaji} alt="Logo" />
                    <h3 className="movie-text">Rajini swag</h3>
                    <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                </div>
                <div className="movie-block2">
                    <img onClick={() => {
                        history.push("/collections-sub");
                    }} className="movie-block" src={vijay} alt="Logo" />
                    <h3 className="movie-text">Romance 101</h3>
                    <div className="time"><h3 className="tstamp">20.9.9</h3></div>
                </div>
            </div>
        </div> */}
            {/* <Countdown  date={Date.now() + 50000000}></Countdown> */}
           <div class="movies">
            <Movies />
            </div>
            {/* top sellers */}
            <div className="home-sellers-card">
                <h1 className="thead">TOP SELLERS <img className="hundred" src={rocket} /></h1>
                <Top_selling_products />
                <div className="check-loadmore">
                    <Link to="/collections"><button className="bbn632-hover bn28 btn-sm">EXPLORE</button></Link>
                </div>
            </div>


            <div className="offical-pattners">
                <div>
                    <p className="o-head">OFFICIAL PARTNERS</p>
                    <img className="o-img" src={o_im} alt="Logo" />
                </div>
                <div className="o-card-all">
                    <div className="o-card">
                        <img className="o-p-img" src={ynot} alt="Logo" />
                        <img className="o-right" src={right} alt="Logo" />
                        <p className="o-text"> YNOT studio</p>
                    </div>
                    <div className="o-card">
                        <img className="o-p-img" src={reliance} alt="Logo" />
                        <img className="o-right" src={right} alt="Logo" />
                        <p className="o-text"> Reliance Entertainment
                        </p>
                    </div>
                    <div className="o-card">
                        <img className="o-p-img" src={avm} alt="Logo" />
                        <img className="o-right" src={right} alt="Logo" />
                        <p className="o-text"> AVM Productions</p>
                    </div>
                    <div className="o-card">
                        <img className="o-p-img" src={tsl} alt="Logo" />
                        <img className="o-right" src={right} alt="Logo" />
                        <p className="o-text"> Thenandal Studios</p>
                    </div>
                    <div className="o-card">
                        <img className="o-p-img" src={sivajilogo} alt="Logo" />
                        <img className="o-right" src={right} alt="Logo" />
                        <p className="o-text"> Sivaji Productions </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

